/* ============================================================
   Re-Coco — Blogs JS
   Handles: tag filter
   ============================================================ */

(function () {
  'use strict';

  document.querySelectorAll('[data-blog-tag]').forEach(btn => {
    btn.addEventListener('click', () => {
      const tag = btn.dataset.blogTag;

      document.querySelectorAll('[data-blog-tag]').forEach(b => {
        b.classList.remove('bg-primary-dark', 'text-white');
        b.classList.add('bg-white', 'border', 'border-border-light');
      });
      btn.classList.add('bg-primary-dark', 'text-white');
      btn.classList.remove('bg-white', 'border', 'border-border-light');

      // Filter articles
      document.querySelectorAll('[data-blog-article]').forEach(article => {
        if (tag === 'All' || article.dataset.blogArticle === tag) {
          article.style.display = '';
        } else {
          article.style.display = 'none';
        }
      });

      // Show/hide featured post
      const featured = document.getElementById('blog-featured');
      if (featured) featured.style.display = tag === 'All' ? '' : 'none';
    });
  });

})();
